(function () {
    'use strict';

    angular.module("imApp").factory("p2WebpageTableService", ['$ihttp', function ($ihttp) {
        let service = {
            listWebPageTables: function (parms) {
                return $ihttp.post({
                    method: 21,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
